import clsx from "clsx";
import { ShapeProps } from "./types";
import DiamondIcon from "@mixitone/icons/diamond.svg";

export const Diamond: React.FC<ShapeProps> = ({ color, size, className, style, children }) => {
  return (
    <div
      className={clsx("relative flex items-center justify-center", className)}
      aria-roledescription="color dot"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        ...style,
      }}
    >
      <DiamondIcon className="absolute inset-0" width={size} height={size} style={{ fill: color }} />
      <span className="relative font-bold">{children}</span>
    </div>
  );
};
